module.exports = __webpack_public_path__ + "static/media/imagem2.9580ba69.jpeg";